class OrganizasyonMailDTO {
    id: number = 0;
    mailAddress?: string = "";
    mailDisplayname?: string = "";
    mailHost?: string = "";
    mailPort?: number = null;
    mailUsername?: string = "";
    mailPassword?: string = "";
    mailSsl?: string = "E";
    mailIcerikHtml?: string = "H";
}
export default OrganizasyonMailDTO;